var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesStandardArc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M12.3,218.5c0,0,0,2.6-0.4,3.7c-0.7,1.8,0.5,2.3,0.5,2.3h208 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.3L12.3,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M12.3,213.2c0,0,0.1,1.9-0.4,3.7c-1.1,2.3,0.5,2.3,0.5,2.3h208 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.3L12.3,213.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M14.9,10.6h205.7l-0.3,193.3c0,0,0.1,1.1,0,4.3 c0.5,1.9,1,5.3-0.5,5.3c-1.6,0-202.7,0-206.8,0c-2.9,0-0.9-2.9-1.2-8.8c0-1.4,0-194.1,0-194.1L14.9,10.6L14.9,10.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStandardArc);
export default __webpack_public_path__ + "static/media/FeaturesStandard_arc.e8e14b1436d2249a48165b81edb53ab5.svg";
export { ForwardRef as ReactComponent };